export default "__VITE_ASSET__CzN7kJEj__"